export default "__VITE_ASSET__C7$PrUe$__"